import { createFileRoute } from "@tanstack/react-router";
import { selectInjectionByInjectingClinicianIdQueryOptions } from "../../features/injection/api/selectInjectionByInjectingClinicianId";
import { selectProfileByIdQueryOptions } from "../../features/profile/api/selectProfile";

const ClinicianAnalyticsPage = () => {
    const { profile, injections } = Route.useLoaderData();
    console.log(profile);
    console.log(injections);
    return (
        <div>
            <h1>{profile.name}</h1>
            <p>{profile.gmc}</p>
        </div>
    );
};

export const Route = createFileRoute("/clinicians/$clinicianId")({
    component: ClinicianAnalyticsPage,
    loader: ({ context, params }) => {
        const { clinicianId } = params as { clinicianId: string };
        const profile = context.queryClient.ensureQueryData(selectProfileByIdQueryOptions(clinicianId));
        const injections = context.queryClient.ensureQueryData(
            selectInjectionByInjectingClinicianIdQueryOptions(clinicianId)
        );
        return { profile, injections };
    },
});
